import analytics_en from './analytics_en.json'
import common_en from './common_en.json'
import common_fr from './common_fr.json'
import contactInfo_en from './contact-info_en.json'
import contactInfo_fr from './contact-info_fr.json'
import cta_en from './cta_en.json'
import cta_fr from './cta_fr.json'
import errorPage_en from './error-page_en.json'
import errorPage_fr from './error-page_fr.json'
import forms_en from './forms_en.json'
import forms_fr from './forms_fr.json'
import loadingPage_en from './loading-page_en.json'
import loadingPage_fr from './loading-page_fr.json'
import rxtable_en from './rxtable_en.json'
import rxtable_fr from './rxtable_fr.json'

const base_resources = {
  en: {
    ...common_en,
    ...errorPage_en,
    ...loadingPage_en,
    ...contactInfo_en,
    ...cta_en,
    ...forms_en,
    ...analytics_en,
    ...rxtable_en,
  },
  fr: {
    ...common_fr,
    ...errorPage_fr,
    ...loadingPage_fr,
    ...contactInfo_fr,
    ...cta_fr,
    ...forms_fr,
    ...analytics_en,
    ...rxtable_fr,
  },
}

export default base_resources
